'use client'

import React from 'react'
import { useTranslations } from 'next-intl'

import type { HolidayBulletListSection } from '@/src/types/holidays'

import HolidayList, { type HolidayListGroup } from './holidayList'

interface HolidayListWrapperProps {
    section: HolidayBulletListSection
    isMobile: boolean
}

const HolidayListWrapper: React.FC<HolidayListWrapperProps> = ({ section, isMobile }) => {
    const t = useTranslations('holidaysPage')
    const defaultVariant = section.variant ?? 'bullet'

    // The top-level `items` are group zero, so the view renders one uniform shape and never
    // branches on "is this the main list or a sub-group".
    const groups: HolidayListGroup[] = []
    if (section.items?.length) {
        groups.push({ variant: defaultVariant, items: section.items })
    }
    for (const group of section.groups ?? []) {
        if (!group.items?.length) continue
        groups.push({ title: group.title, variant: group.variant ?? defaultVariant, items: group.items })
    }

    if (!groups.length) return null

    return (
        <HolidayList
            groups={groups}
            footnotes={section.footnotes ?? []}
            showMoreLabel={count => t('listShowMore', { count })}
            showLessLabel={t('listShowLess')}
            isMobile={isMobile}
        />
    )
}

export { HolidayListWrapper }
export default HolidayListWrapper
